import { render } from "./Sso-cofanet.vue?vue&type=template&id=43f26ec4&scoped=true"
import script from "./Sso-cofanet.vue?vue&type=script&lang=js"
export * from "./Sso-cofanet.vue?vue&type=script&lang=js"

import "./Sso-cofanet.vue?vue&type=style&index=0&id=43f26ec4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43f26ec4"]])

export default __exports__